import { useEffect, useState } from "react"
import { Container, Row, Col, Button, Form, InputGroup, Modal } from 'react-bootstrap';
import DOMPurify from "dompurify";
import { aiService } from "../../service/api.service";
import { TableSkeletonRows } from "../loader";
import swal from "sweetalert";
import { TablePagination } from "../common/TablePagination";
import { StyledTable, StyledTableHeader, StyledTableCell, StyledTableRow } from "../common/StyledTable";

export function CallList() {
  const [calls, setCalls] = useState([])
  const [page, setPage] = useState(1)
  const [summary, setSummary] = useState("")
  const [summaryModal, setSummaryModal] = useState(false)
  const [totalItems, setTotalItems] = useState(1)
  const [callNum, setCallNum] = useState("")
  const [loader, setLoader] = useState(false);
  const page_size = 10

  useEffect(() => {
    getCallList()
  }, [page])

  async function getCallList() {
    try {
      setLoader(true)
      const params = {
        page: page,
        limit: page_size
      }
      const list = await aiService.callListGpt(params)
      setCalls(list.data.data)
      setTotalItems(list.data.total_items)
      setLoader(false)
    } catch (error) {
      setLoader(false)
      if (error?.response?.status == 401) {
        swal({ icon: 'error', text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
        });
      } else {
        swal({ icon: 'error', text: error?.response?.data?.message ? error?.response?.data?.message : error?.message, button: "OK" })
      }
    }
  }

  function handlePageChange(pageNumber) {
    setPage(pageNumber);
  }

  async function makeCall(phone) {
    try {
      if (!phone) {
        swal({ icon: "warning", text: "Kindly enter phone number." })
        return;
      }
      setLoader(true)
      await aiService.makeGptCall({ 'phone': phone })
      setLoader(false)
      swal({ icon: "success", text: "Call created successfully." })
      setPage(page)
    } catch (error) {
      setLoader(false)
      if (error?.response?.status == 401) {
        swal({ icon: 'error', text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear()
          window.location.href = "/";
        });
      } else {
        swal({ icon: "error", text: error.response.data.message })
      }
    }
  }

  return (
    <div className="dashboard-main-area company-list-area">
      <Container fluid>
        <div className="dashboard-area-heading management-heading">
          <div className="under-content-section">
            <div>
              <h1 className="company-page-title">Call List</h1>
              <h5 className="company-page-subtitle">{calls.length} of {totalItems} calls</h5>
            </div>
            <div className="header-actions-right call-input-actions d-flex align-items-center gap-2">
              <Form.Control placeholder="Enter number to call. E.g. +151xxxxxxx" value={callNum} onChange={(e) => setCallNum(e.target.value)} />
              <Button variant="success" onClick={() => makeCall(callNum)}>Call</Button>
            </div>
          </div>
          <Row className="pb-4 justify-content-center">
            <Col md={12}>
              <div className="audit-request-box premium-company-card">
                <StyledTable responsive="sm" className="UserListTable premium-user-list-table">
                  <thead>
                    <StyledTableRow>
                      <StyledTableHeader>Caller Name</StyledTableHeader>
                      <StyledTableHeader>Email</StyledTableHeader>
                      <StyledTableHeader>Number</StyledTableHeader>
                      <StyledTableHeader>Action</StyledTableHeader>
                    </StyledTableRow>
                  </thead>
                  <tbody>
                    {loader ? (
                      <TableSkeletonRows rows={page_size} columns={4} />
                    ) : calls.map((call, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell>{call.full_name}</StyledTableCell>
                        <StyledTableCell>{call.email}</StyledTableCell>
                        <StyledTableCell>{call.to_number}</StyledTableCell>
                        <StyledTableCell>
                          <Button variant="success" onClick={() => makeCall(call.to_number)}>Call back</Button>
                          {
                            call.summary && (
                              <button className="btn btn-success ms-3" onClick={() => {
                                setSummary(call.summary)
                                setSummaryModal(true)
                              }}>View Summary</button>
                            )
                          }
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </tbody>
                </StyledTable>
                <TablePagination
                  activePage={page}
                  itemsCountPerPage={page_size}
                  totalItemsCount={totalItems}
                  onChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Modal show={summaryModal} onHide={() => {
        setSummaryModal(false)
        setSummary("")
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Call Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }}></p>
        </Modal.Body>
      </Modal>
    </div>
  )
}
